export default "__VITE_ASSET__kr$dROJk__"